var users =[
    {
      "id": 1,
      "name": "Leanne Graham",
      "username": "Bret",
      "email": "Sincere@april.biz",
      "image":"https://media-exp1.licdn.com/dms/image/C5603AQH_xN5TZ4yAZg/profile-displayphoto-shrink_200_200/0?e=1587600000&v=beta&t=9exnRQO0l-zHvKx8uwgpTY9NyysMAWi_qM_eUhwJPdY",
      "address": {
        "street": "Kulas Light",
        "suite": "Apt. 556",
        "city": "Gwenborough",
        "zipcode": "92998-3874",
        "geo": {
          "lat": "-37.3159",
          "lng": "81.1496"
        }
      },
      "annual_salary":56000,
      "phone": "1-770-736-8031 x56442",
      "website": "hildegard.org",
      "company": {
        "cname": "Romaguera-Crona",
        "catchPhrase": "Multi-layered client-server neural-net",
        "bs": "harness real-time e-markets"
      }
    },
    {
      "id": 2,
      "name": "Ervin Howell",
      "username": "Antonette",
      "email": "Shanna@melissa.tv",
      "image":"https://upload.wikimedia.org/wikipedia/commons/c/ce/Michael_Dell_2010.jpg",
      "address": {
        "street": "Victor Plains",
        "suite": "Suite 879",
        "city": "Wisokyburgh",
        "zipcode": "90566-7771",
        "geo": {
          "lat": "-43.9509",
          "lng": "-34.4618"
        }
      },
      "annual_salary":142000,
      "phone": "010-692-6593 x09125",
      "website": "anastasia.net",
      "company": {
        "cname": "Deckow-Crist",
        "catchPhrase": "Proactive didactic contingency",
        "bs": "synergize scalable supply-chains"
      }
    },
    {
      "id": 3,
      "name": "Clementine Bauch",
      "username": "Samantha",
      "email": "Nathan@yesenia.net",
      "image":"https://images.livemint.com/img/2019/06/19/600x338/fa76617e-9277-11e9-932b-3578ec0f3acf_1560972736095_1560974546043.jpg",
      "address": {
        "street": "Douglas Extension",
        "suite": "Suite 847",
        "city": "McKenziehaven",
        "zipcode": "59590-4157",
        "geo": {
          "lat": "-68.6102",
          "lng": "-47.0653"
        }
      },
      "annual_salary":172000,
      "phone": "1-463-123-4447",
      "website": "ramiro.info",
      "company": {
        "cname": "Romaguera-Jacobson",
        "catchPhrase": "Face to face bifurcated interface",
        "bs": "e-enable strategic applications"
      }
    },
    {
      "id": 4,
      "name": "Patricia Lebsack",
      "username": "Karianne",
      "email": "Julianne.OConner@kory.org",
      "image":"https://media-exp1.licdn.com/dms/image/C5603AQHHUuOSlRVA1w/profile-displayphoto-shrink_200_200/0?e=1590019200&v=beta&t=xg6m7b-yuGdMcZE3O4JDHpQ_rrp6RqawzvCLQ6ge_W4",
      "address": {
        "street": "Hoeger Mall",
        "suite": "Apt. 692",
        "city": "South Elvis",
        "zipcode": "53919-4257",
        "geo": {
          "lat": "29.4572",
          "lng": "-164.2990"
        }
      },
      "annual_salary":90000,
      "phone": "493-170-9623 x156",
      "website": "kale.biz",
      "company": {
        "cname": "Robel-Corkery",
        "catchPhrase": "Multi-tiered zero tolerance productivity",
        "bs": "transition cutting-edge web services"
      }
    },
    {
      "id": 5,
      "name": "Chelsey Dietrich",
      "username": "Kamren",
      "email": "Lucio_Hettinger@annie.ca",
      "image":"https://pbs.twimg.com/profile_images/595243565900374016/6OoNrLqS_400x400.jpg",
      "address": {
        "street": "Skiles Walks",
        "suite": "Suite 351",
        "city": "Roscoeview",
        "zipcode": "33263",
        "geo": {
          "lat": "-31.8129",
          "lng": "62.5342"
        }
      },
      "annual_salary":36000,
      "phone": "(254)954-1289",
      "website": "demarco.info",
      "company": {
        "cname": "Keebler LLC",
        "catchPhrase": "User-centric fault-tolerant solution",
        "bs": "revolutionize end-to-end systems"
      }
    },
    {
      "id": 6,
      "name": "Mrs. Dennis Schulist",
      "username": "Leopoldo_Corkery",
      "email": "Karley_Dach@jasper.info",
      "image":"https://upload.wikimedia.org/wikipedia/commons/c/c8/Rupert_Murdoch_-_Flickr_-_Eva_Rinaldi_Celebrity_and_Live_Music_Photographer.jpg",
      "address": {
        "street": "Norberto Crossing",
        "suite": "Apt. 950",
        "city": "South Christy",
        "zipcode": "23505-1337",
        "geo": {
          "lat": "-71.4197",
          "lng": "71.7478"
        }
      },
      "annual_salary":112000,
      "phone": "1-477-935-8478 x6430",
      "website": "ola.org",
      "company": {
        "cname": "Considine-Lockman",
        "catchPhrase": "Synchronised bottom-line interface",
        "bs": "e-enable innovative applications"
      }
    },
    {
      "id": 7,
      "name": "Kurtis Weissnat",
      "username": "Elwyn.Skiles",
      "email": "Telly.Hoeger@billy.biz",
      "image":"https://static01.nyt.com/images/2020/04/07/business/07virus-dorsey/07virus-dorsey-mediumSquareAt3X.jpg",
      "address": {
        "street": "Rex Trail",
        "suite": "Suite 280",
        "city": "Howemouth",
        "zipcode": "58804-1099",
        "geo": {
          "lat": "24.8918",
          "lng": "21.8984"
        }
      },
      "annual_salary":45000,
      "phone": "210.067.6132",
      "website": "elvis.io",
      "company": {
        "cname": "Johns Group",
        "catchPhrase": "Configurable multimedia task-force",
        "bs": "generate enterprise e-tailers"
      }
    },
    {
      "id": 8,
      "name": "Nicholas Runolfsdottir V",
      "username": "Maxime_Nienow",
      "email": "Sherwood@rosamond.me",
      "image":"https://arizent.brightspotcdn.com/07/1c/4e8154374800bca79c559d4d5ece/2018-mpwif-2-johnson-abigail-fidelity.jpg",
      "address": {
        "street": "Ellsworth Summit",
        "suite": "Suite 729",
        "city": "Aliyaview",
        "zipcode": "45169",
        "geo": {
          "lat": "-14.3990",
          "lng": "-120.7677"
        }
      },
      "annual_salary":25000,
      "phone": "586.493.6943 x140",
      "website": "jacynthe.com",
      "company": {
        "cname": "Abernathy Group",
        "catchPhrase": "Implemented secondary concept",
        "bs": "e-enable extensible e-tailers"
      }
    },
    {
      "id": 9,
      "name": "Glenna Reichert",
      "username": "Delphine",
      "email": "Chaim_McDermott@dana.io",
      "image":"https://www.yourtechstory.com/wp-content/uploads/2018/11/jen-hsun-huang.jpg",
      "address": {
        "street": "Dayna Park",
        "suite": "Suite 449",
        "city": "Bartholomebury",
        "zipcode": "76495-3109",
        
        "geo": {
          "lat": "24.6463",
          "lng": "-168.8889"
        }
      },
      "annual_salary":82000,
      "phone": "(775)976-6794 x41206",
      "website": "conrad.com",
      "company": {
        "cname": "Yost and Sons",
        "catchPhrase": "Switchable contextually-based project",
        "bs": "aggregate real-time technologies"
      }
    },
    {
      "id": 10,
      "name": "Clementina DuBuque",
      "username": "Moriah.Stanton",
      "email": "Rey.Padberg@karina.biz",
      "image":"https://boston.citybizlist.com/media/images/medium/1538396581_H.%20Lawrence%20Culp.jpg",
      "address": {
        "street": "Kattie Turnpike",
        "suite": "Suite 198",
        "city": "Lebsackbury",
        "zipcode": "31428-2261",
        "geo": {
          "lat": "-38.2386",
          "lng": "57.2232"
        }
      },
      "annual_salary":65000,
      "phone": "024-648-3804",
      "website": "ambrose.net",
      "company": {
        "cname": "Hoeger LLC",
        "catchPhrase": "Centralized empowering task-force",
        "bs": "target end-to-end models"
      }
    },
    {
        "id": 11,
        "name": "Arnold Schwarzenegger",
        "username": "arnold.schwarzenegger",
        "email": "arnold.schwarzenegger@gmail.com",
        "image":"https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSZckcvwVbEVm4-OIXq7uQT9Dt4CG7WsIuxZWMRmxtRHeutnOkV&usqp=CAU",
        "annual_salary":206500,
        "address": {
          "street": "Kattie Turnpike",
          "suite": "Sheldon Stone's House",
          "city": "Los Angeles",
          "zipcode": "21518-1241",
          "geo": {
            "lat": "-38.2386",
            "lng": "57.2232"
          }
        },
        "phone": "024-648-3804",
        "website": "arnoldschwarzenegger.net",
        "company": {
        "cname": "Hollywood",
          "catchPhrase": "Centralized empowering task-force",
          "bs": "target end-to-end models"
        }
      },
      {
        "id": 12,
        "name": "Elon Musk",
        "username": "elon.musk",
        "email": "elon.musk@yahoo.com",
        "image":"https://www.gstatic.com/tv/thumb/persons/487130/487130_v9_ba.jpg",
        "address": {
          "street": "Brentwood",
          "suite": "Apt 112",
          "city": "California",
          "zipcode": "21518-1241",
          "geo": {
            "lat": "-38.2386",
            "lng": "57.2232"
          }
        },
        "annual_salary": 49920,
        "phone": "024-648-3804",
        "website": "elonmask.net",
        "company": {
        "cname": "SpaceX",
          "catchPhrase": "Centralized empowering task-force",
          "bs": "target end-to-end models"
        }
      },
      {
        "id": 13,
        "name": "Brendan Kennedy",
        "username": "Brendan Kennedy",
        "email": "brendan.kennedy@yahoo.com",
        "image":"https://images.squarespace-cdn.com/content/v1/5488a9e6e4b0563d5788db1a/1443466881079-00T63XWT57Z8BPCSTRV4/ke17ZwdGBToddI8pDm48kLgPtI1CId2Nrt9Hvh06PO1Zw-zPPgdn4jUwVcJE1ZvWEtT5uBSRWt4vQZAgTJucoTqqXjS3CfNDSuuf31e0tVFhAvysz1pXHIF-fi91h997uhiFEEkxD1L9CxEdKdZC8x4D6B1eHC3o-jX9VCINKDc/catherine_larger_image_web.jpg",
        "address": {
          "street": "Berkley",
          "suite": "Apt. 556",
          "city": "California",
          "zipcode": "21518-1241",
          "geo": {
            "lat": "-38.2386",
            "lng": "57.2232"
          }
        },
        "annual_salary": 11300000,
        "phone": "024-648-3804",
        "website": "brendankennedy.net",
        "company": {
        "cname": "Tilray",
          "catchPhrase": "Centralized empowering task-force",
          "bs": "target end-to-end models"
        }
      },
      {
        "id": 14,
        "name": "Bob Iger",
        "username": "Bob Iger",
        "email": "bob.iger@gmail.com",
        "image":"https://image.cnbcfm.com/api/v1/image/100939777-145761404.jpg?v=1532564652&w=1400&h=950",
        "address": {
          "street": "St Peter",
          "suite": "Apt. 161",
          "city": "New York",
          "zipcode": "21518-1241",
          "geo": {
            "lat": "-38.2386",
            "lng": "57.2232"
          }
        },
        "annual_salary": 65600000,
        "phone": "024-648-3804",
        "website": "brendankennedy.net",
        "company": {
        "cname": "Walt Disney",
          "catchPhrase": "Centralized empowering task-force",
          "bs": "target end-to-end models"
        }
      },
      {
        "id": 15,
        "name": "David Zaslav ",
        "username": "David Zaslav",
        "email": "david.zaslav @gmail.com",
        "image":"https://media.bizj.us/view/img/10223243/david-zaslav-september-2016*750xx2000-2667-0-0.jpg",
        "address": {
          "street": "Brooklyn",
          "suite": "Apt. 161",
          "city": "New York",
          "zipcode": "21518-1241",
          "geo": {
            "lat": "-38.2386",
            "lng": "57.2232"
          }
        },
        "annual_salary": 3000000,
        "phone": "024-648-3804",
        "website": "brendankennedy.net",
        "company": {
        "cname": "Discovery",
          "catchPhrase": "Centralized empowering task-force",
          "bs": "target end-to-end models"
        }
      },
  ];
  export default users;